import SpinnerIcon from "@/icons/ui/feedback/spinner.svg";

import styled from "./style.module.scss";

export default function Loader() {
  return (
    <div className={styled.container}>
      <SpinnerIcon
        width="120"
        height="120"
        stroke="#4D4D4D"
        className={styled.rotating}
      />
    </div>
  );
}
